import apiClient from './api';
import type {
  CompanyInvitationInfo,
  AcceptInvitationResponse,
} from '../types/team';

export const invitationService = {
  getInvitation: async (token: string): Promise<CompanyInvitationInfo> => {
    const response = await apiClient.get<CompanyInvitationInfo>(`/invitations/${token}`);
    return response.data;
  },

  acceptInvitation: async (token: string): Promise<AcceptInvitationResponse> => {
    const response = await apiClient.post<AcceptInvitationResponse>(`/invitations/${token}/accept`);
    return response.data;
  },
};
